import { Injectable } from '@angular/core';
import { RequestService } from '@app/core/request/request.service';
import { Observable } from 'rxjs';
// Import to mock invoices locally
import { Response } from '@app/core/interfaces';
import { TotaalFacturenInterface } from '@app/core/interfaces/totaal-facturen.interface';
import { VaststellingFactuurInterface } from '@app/core/interfaces/vaststelling-factuur.interface';
import { map } from 'rxjs/operators';

/** @deprecated moved to libs folder */
@Injectable({
    providedIn: 'root'
})
export class InvoicesService {

    constructor(
        private request: RequestService,
    ) { }

    public getInvoices(jaartal: number): Observable<TotaalFacturenInterface> {
        const payload = {
            jaartal
        };

        // uncomment this part below to mock invoices locally, please do not delete
        // return of({ factuur, te_betalen_ideal, jaartallen });

        return this.request.post('relatie-financieel/opvragen/totaal-facturen', payload).pipe(
            map(result => result.data)
        );
    }

    public getInvoiceDetail(factuur_id: string): Observable<VaststellingFactuurInterface> {
        const payload = {
            factuur_id
        };

        return this.request.post('relatie-financieel/opvragen/vaststelling-factuur', payload).pipe(
            map(result => result.data)
        );
    }

    public setPayment(factuur_id: string, bank_id: string): Observable<Response> {
        const payload = {
            factuur: { factuur_id },
            bank: { bank_id }
        };

        return this.request.post('relatie-financieel/betalen/factuur-factuurnummer', payload);
    }
}
